import { DesktopWindow, WindowContent, WindowTitleBar } from "desktopWindow/components/DesktopWindow";
import { useWindowTile } from "desktopWindow/context/WindowTilesContext";
import ExtensionIcon from "@mui/icons-material/Extension";
import { useEffect, useRef } from "react";
import { PuzzleGamePlugin } from "interfaces/puzzle-game-plugin";
import { useSocketContext } from "context/SocketContext";

interface Props {
	// Window tile id
	tileId: string;
}
export const EmbeddedPuzzleWindow = ({ tileId }: Props) => {
	const { socket } = useSocketContext();
	const iframeRef = useRef<HTMLIFrameElement>(null);
	const { componentProps, close } = useWindowTile(tileId);
	const puzzleGamePlugin: PuzzleGamePlugin = componentProps.puzzleGamePlugin!;
	useEffect(() => {
		function onMessage(evt: MessageEvent<{ completed: boolean; puzzleKey: string }>) {
			if (evt.source === iframeRef.current?.contentWindow && evt.data.completed) {
				console.debug(evt.data);
				// Notify Backend that an embedded puzzle has been solved
				socket?.emit("onEmbeddedPuzzleSolved", { puzzleGamePlugin });

				if (puzzleGamePlugin?.solvePuzzleIds?.length) {
					// If the puzzle is supposed to solve an Answer, then close the window.
					window.setTimeout(() => close(), 10000);
				}
			} else {
				console.debug("Somebody else's evt", evt.data);
			}
		}
		window.addEventListener("message", onMessage);
		return () => {
			window.removeEventListener("message", onMessage);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [puzzleGamePlugin, socket]);
	return (
		<DesktopWindow id={tileId}>
			<WindowTitleBar icon={<ExtensionIcon height="30" width="30" />} />

			<WindowContent style={{ overflow: "hidden" }}>
				<iframe
					ref={iframeRef}
					title={puzzleGamePlugin.name}
					src={puzzleGamePlugin.pluginEmbedUrl}
					width="100%"
					height="100%"
				></iframe>
			</WindowContent>
		</DesktopWindow>
	);
};
